export enum PermissionLevel {
    SystemOwner = 'System Owner',
    DecisionMaker = 'Decision Maker',
    Contributor = 'Contributor',
    Analyst = 'Analyst',
}
